<template>
  <article class="index-page">
    <transition name="indexTab" mode="out-in"><scope-index v-show="currentPage == 1"></scope-index></transition>
    <transition name="indexTab" mode="out-in"><my-order-list v-show="currentPage == 2" ref="orderlist"></my-order-list></transition>
    <transition name="indexTab" mode="out-in"><my-user-setting v-show="currentPage == 3"></my-user-setting></transition>
    <nav-footer @changePage="changePage" ref="navfooter"></nav-footer>
  </article>
</template>

<script>
import NavFooter from './child-components/NavFooter';
import ScopeIndex from './shopQueryIndex';
import MyOrderList from './shopOrderList';
import MyUserSetting from './MyUserSetting';

export default {
  name: 'shopIndexPage',
  data() {
    return {
      currentPage: 1
    };
  },
  components: {
    NavFooter,
    ScopeIndex,
    MyOrderList,
    MyUserSetting
  },
  activated() {
        this.getPageParams();
  },
  mounted() {

  },
  methods: {
    getPageParams() {
      let that = this;
      if (this.$route.params.page) {
        switch (this.$route.params.page) {
          case 'scopeindex':
            // this.changePage(1);
            this.$refs.navfooter.changePage(1);
            break;
          case '':
            this.$refs.navfooter.changePage(1);
            break;
          case 'myorder':
            // this.changePage(2);
            this.$refs.navfooter.changePage(2);
            break;
          case 'myuser':
            // this.changePage(3);
            this.$refs.navfooter.changePage(3);
            break;
        }
      } else {
        this.$refs.navfooter.changePage(1);
      }
    },
    changePage(page) {
      this.currentPage = page;
      switch (page) {
        case 1:
          document.title = '商城首页';
          break;
        case 2:
          this.$refs.orderlist.getOrderList();
          document.title = '我的商城订单';
          break;
        case 3:
          document.title = '个人中心';
          break;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import '../style/public';
.index-page {
  height: 100%;
  overflow: hidden;
  .flex_wrap(space-between, initial, initial, column);
}
</style>



// WEBPACK FOOTER //
// src/components/shopIndexPage.vue